import React from 'react';

import './styles.scss';

interface ITooltipProps {
  'data-for': string;
  'data-tip': string;
}

export interface ITextProps {
  children: any;
  size: number;
  className?: string;
  style?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  > &
    Partial<ITooltipProps>;
  onClick?: React.MouseEventHandler<HTMLSpanElement> | undefined;
}

const Text = (props: ITextProps) => {
  return (
    <span
      className={`text text--${props.size} ${
        props.className ? props.className : ''
      } ${props.onClick ? 'text--clickable' : ''}`}
      {...props.style}
      onClick={props.onClick}
    >
      {props.children}
    </span>
  );
};

export default Text;
